import {getOwnedNodes, isNumberLikeNode} from "@cm/template-nodes"
import {ChangeDetectionStrategy, Component, computed} from "@angular/core"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {ValueSlotComponent, SelectionPossibilities} from "@template-editor/components/value-slot/value-slot.component"
import {findClosestParentComponentGraph, collectMattressNodes, isMattressReferenceFrameLikeNode} from "@cm/mattress-nodes"
import type {NumberLikeNode} from "@cm/template-nodes"
import type {MattressReferenceFrame, MattressReferenceFrameParameters, MattressReferenceFrameLikeNode} from "@cm/mattress-nodes"

@Component({
    selector: "cm-mattress-reference-frame-inspector",
    templateUrl: "./mattress-reference-frame-inspector.component.html",
    styleUrls: ["./mattress-reference-frame-inspector.component.scss"],
    imports: [InspectorSectionComponent, ValueSlotComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MattressReferenceFrameInspectorComponent extends BaseInspectorComponent<MattressReferenceFrame> {
    readonly $availableNumberParameters = computed((): SelectionPossibilities<NumberLikeNode> => {
        const node = this.$node()
        const parentGraph = findClosestParentComponentGraph(node)
        return getOwnedNodes(parentGraph)
            .filter(isNumberLikeNode)
            .map((n) => ({
                name: typeof n.parameters.name === "string" ? n.parameters.name : String(n.parameters.value),
                value: n,
            }))
    })

    readonly $referenceFrameParentSelectionPossibilities = computed((): SelectionPossibilities<MattressReferenceFrameLikeNode | "global"> => {
        const node = this.$node()
        const parentGraph = findClosestParentComponentGraph(node)
        const frames = [...collectMattressNodes(parentGraph, isMattressReferenceFrameLikeNode)].filter((rf) => rf !== node)
        return [{name: "Global", value: "global" as const}, ...frames.map((rf) => ({name: rf.parameters.name, value: rf}))]
    })

    readonly referenceFrameTypeSelectionPossibilities: SelectionPossibilities<MattressReferenceFrameParameters["type"]> = [
        {name: "X Axis Ring", value: "xAxisRing"},
        {name: "Y Axis Ring", value: "yAxisRing"},
        {name: "Z Axis Ring", value: "zAxisRing"},
    ]
}
